import { publishReducer } from "./reducers/fetchReducers";

const generalReducers = {
  publishGlobalStore: publishReducer,
};

export { generalReducers };
